<ui-detail-section
    [title]="'Rahmenbedingungen'"
>
    <div class="prevention-framework">
        <div class="prevention-framework__row">
            <div class="prevention-framework__col">
                @if (mapItem().timeframe; as timeframe) {
                    <ui-detail-description
                        [title]="'Zeitrahmen / Ablauf:'"
                        [htmlDescription]="timeframe"
                    />
                }

                @if (mapItem().venues; as venues) {
                    <ui-detail-description
                        [title]="'Ort(e) der Durchführung:'"
                        [htmlDescription]="venues.join(', ')"
                    />
                }
            </div>
            <div class="prevention-framework__col">
                @if (mapItem().measureKind) {
                    <ui-detail-description
                        [title]="'Art(en) des Angebots:'"
                        [htmlDescription]="mapItem().measureKind.join(', ')"
                    />
                }
                @if (mapItem().cost; as cost) {
                    <ui-detail-description
                        [title]="'Kosten:'"
                        [htmlDescription]="cost"
                    />
                }
            </div>
        </div>
    </div>
</ui-detail-section>
